import { createAsyncThunk as _createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface indexSecondInfoI {
  showType: string
  infoKey: string
  infoValue: string
}

const initialState: indexSecondInfoI = {
  // 展示卡片类型：人物/画作
  showType: '',
  // 展示信息的所属类型：技法/馆藏...
  infoKey: '',
  // 展示信息的具体值：工笔/故宫博物院...
  infoValue: ''
}

export const setIndexSecondInfoSlice = createSlice({
  name: 'setIndexSecondInfo',
  initialState,
  reducers: {
    setShowType: (state, action: PayloadAction<string>) => {
      state.showType = action.payload
    },
    setInfoKey: (state, action: PayloadAction<string>) => {
      state.infoKey = action.payload
    },
    setInfoValue: (state, action: PayloadAction<string>) => {
      state.infoValue = action.payload
    }
  }
})
export const { setShowType, setInfoKey, setInfoValue } = setIndexSecondInfoSlice.actions
export default setIndexSecondInfoSlice.reducer
